import { Navigate, Outlet } from "react-router-dom";
import AuthLoading from "@/pages/(auth)/loading.tsx";
import { useAuth } from "@babackapp/auth-client/hooks";

export default function AuthLayout() {
  const auth = useAuth();

  if (auth.isAuthenticating) {
    return <AuthLoading />;
  }

  if (auth.isAuthenticated) {
    return <Navigate to={"/"} replace />;
  }

  return <Outlet />;
}
